import { useSetDefaultEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-set-default-email-options'
import {
  DashboardMailEditorProps,
  ExtendedState,
} from 'shared/components/dashboard-mail-editor/types/common'
import { useSetDefaultSenderEmail } from 'shared/components/sender-email-select/hooks/use-set-default-sender-email'

export const useSetDefaultEmail = <T extends ExtendedState = ExtendedState>(
  data: DashboardMailEditorProps<T>['tempState'],
  onChange: DashboardMailEditorProps<T>['onChangeEmail'],
  options?: Pick<DashboardMailEditorProps<T>, 'withRecipient'>,
) => {
  useSetDefaultEmailOptions(data, onChange, options)

  useSetDefaultSenderEmail(
    data?.fromEmail,
    value => data && onChange({ ...data, fromEmail: value }),
  )
}
